import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

import {
  tinaField as TinaField,
  useTina as useTinaHook,
} from "tinacms/dist/react";

import { client } from "../tina/__generated__/client";
import { FlagEn, FlagEs } from "@/assets";

export const tinaClient = client;
export const useTina = useTinaHook;
export const tinaField = TinaField;

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// TODO: Remove duplicate of this
export const LOCALES = [
  {
    label: "English",
    value: "en",
    flag: FlagEn,
  },
  {
    label: "Español",
    value: "es",
    flag: FlagEs,
  },
];

export const locales = ["en", "es"];
export const defaultLocale = "en";

export async function getStaticParams() {
  return locales.map((lang) => ({ lang }));
}

const DEFAULT_SEO = {
  title: "Emerald Power",
  description:
    "Calculate your carbon footprint with our carbon reporting software. Set targets for reduction and streamline carbon reporting.",
  keywords:
    "carbon footprint, carbon reporting, carbon reduction, carbon reporting software, carbon reporting tools, carbon reporting solutions, carbon reporting services, carbon reporting products, carbon reporting systems, carbon reporting platforms, carbon reporting software solutions, carbon reporting software products, carbon reporting software systems, carbon reporting software platforms",
};

export const defaultMetadata = DEFAULT_SEO;

export function formatMetadata({ locale, seo = {}, pagePath = "/" }) {
  try {
    // Create alternates for hreflang tags
    const alternateLanguages = {};
    locales.forEach((l) => {
      alternateLanguages[l] =
        l === defaultLocale ? pagePath : `/${l}${pagePath}`;
    });

    // Format the canonical URL based on locale
    const canonicalUrl =
      locale === defaultLocale ? pagePath : `/${locale}${pagePath}`;

    return {
      title: seo.title ? `${seo.title} | Emerald Power` : "Emerald Power",
      description: seo.description || DEFAULT_SEO.description,
      keywords: seo.keywords || DEFAULT_SEO.keywords,
      canonical: canonicalUrl,
      alternates: {
        canonical: canonicalUrl,
        languages: alternateLanguages,
      },
      openGraph: {
        type: "website",
        siteName: "Emerald Power",
        title: seo.title ? `${seo.title} | Emerald Power` : "Emerald Power",
        description: seo.description || DEFAULT_SEO.description,
        url: `https://emeraldpower.io${canonicalUrl}`,
        images: [
          {
            url: "https://res.cloudinary.com/dhr0wjkar/image/upload/v1743962327/Emerald_Power_Website_xf3qaq.png",
            width: 1200,
            height: 630,
            alt: "Emerald Power",
          },
        ],
        locale: locale,
        alternateLocale: locales.filter((l) => l !== locale),
      },
    };
  } catch (error) {
    console.error(`Error formatting metadata:`, error);
    return DEFAULT_SEO;
  }
}
